import React from 'react';
import { ReferencePage } from './ReferencePage';
import { ProductCategoryForm } from '../../components/ProductCategoryForm';
import { useData } from '../../contexts/DataContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { TABLE_COLUMNS } from '../../constants/tables';
import { ProductCategory } from '../../types';

export const ProductCategoriesPage: React.FC = () => {
  const { t } = useLanguage();
  const { productCategories } = useData();

  return (
    <ReferencePage<ProductCategory>
      title={t('references.productCategories')}
      items={productCategories.items}
      columns={TABLE_COLUMNS.PRODUCT_CATEGORIES}
      onAdd={productCategories.add}
      onEdit={productCategories.edit}
      onDelete={productCategories.remove}
      renderForm={({ theme, initialData, onSubmit, onCancel }) => (
        <ProductCategoryForm
          theme={theme}
          initialData={initialData}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      )}
    />
  );
};
